import { render, staticRenderFns } from "./PerfConfig.vue?vue&type=template&id=3bf8f63e&scoped=true"
import script from "./PerfConfig.vue?vue&type=script&lang=js"
export * from "./PerfConfig.vue?vue&type=script&lang=js"
import style0 from "./PerfConfig.vue?vue&type=style&index=0&id=3bf8f63e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf8f63e",
  null
  
)

export default component.exports